<template>
  <div v-show="IsShow" class="messageContent">
    <div class="message_jiantou"></div>
    <div class="system-message">
      <div class="system-message-container">
        <div class="system-message-header">
          <div class="system-message-header__left">消息通知</div>
          <div class="system-message-header__right">
            <el-checkbox v-model="messageSwitch" @change="triggerSwitch">
              <span class="checkbox-info">接收新消息</span>
            </el-checkbox>
            <!-- 勾选提示 -->
            <div v-if="!messageSwitch" class="checkbox-tip">
              <div class="checkbox-tip__icon">
                <i class="icon iconfont icon-zhiyinjiantou"></i>
              </div>
              <div class="checkbox-tip__text">
                <span>勾选此处以接收新消息</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="messageListTotal > 0" class="system-message-main">
          <div class="system-message-main__top">
            <div class="system-message-main__top_unread">
              <!-- 未读 -->
              <!-- 给组件绑定事件时，需要加上.native修饰符，不然不会生效 -->
              <system-message-item
                v-for="(item, index) in messageList.showUnreadList"
                :key="item.CreateTime + index"
                @click.native="changeMessageState(item)"
                :itemInfo="item"
                type="light"
              ></system-message-item>
            </div>
            <div
              class="system-message-main__top_split"
              v-if="
                messageList.showReadList.length > 0 &&
                messageList.showUnreadList.length > 0
              "
            ></div>
            <div
              v-if="messageList.readList.length > 0"
              class="system-message-main__top_read"
            >
              <!-- 已读 -->
              <system-message-item
                v-for="(item, index) in messageList.showReadList"
                :key="item.CreateTime + index"
                @click.native="changeMessageState(item)"
                :itemInfo="item"
                type="dark"
              ></system-message-item>
            </div>

            <!-- 底部 -->
            <div
              :class="{
                'system-message-main_top_bottom': true,
                'padding-bottom-10': moreBtn,
              }"
              v-if="messageListTotal > 0"
            >
              <div class="message-tip">
                <span v-if="moreBtn" @click="showMoreDate"
                  >更多通知<i class="el-icon-arrow-down"></i
                ></span>
                <span v-else>暂时没有更多消息～</span>
              </div>
            </div>
          </div>
          <div class="system-message-main__bottom" v-if="!moreBtn"></div>
        </div>
        <div v-else class="system-message-empty">
          <div>
            <i class="icon iconfont icon-wuxinxiaoxi"></i>
            <span>暂时没有收到消息哦</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { post, fetch, Del, put } from "@/ask/axios";
import systemMessageItem from "./systemMessageItem.vue";
export default {
  components: { systemMessageItem },
  props: {
    value: {
      type: Number,
      required: true,
      default: 0,
    },
    IsShow: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      messageSwitch: true, // 消息开关
      messageList: {
        readList: [], // 已读
        unreadList: [], // 未读
        showReadList: [],
        showUnreadList: [], // 未读
      },
      messageListTotal: 0,
      moreBtn: false, // 更多消息按钮
      timer: null, // 定时获取数据
    };
  },
  watch: {
    // 路由变化时
    $route(to, from) {
      this.getMessageList();
    },
  },
  created() {
    // 获取消息列表
    this.getMessageList();
  },
  mounted() {
    // 每30分钟获取一次消息数据
    let that = this;
    this.timer = setInterval(() => {
      that.getMessageList();
    }, 1000 * 60 * 30);
  },
  methods: {
    // 获取消息列表
    async getMessageList() {
      // 先获取接收新消息开关状态
      await this.getSwitchStatus();

      const url = this.$api04 + "Basics/api/CustomerNoticeMsg/GetCustomerNoticeMsgs";

      const res = await fetch(url);
      if (res.IsOK) {
        // 判断接收消息开关是否开启，不开启数据未空
        let messageList = this.messageSwitch ? res.Results : [];

        // 消息总条数
        this.messageListTotal = messageList.length;

        this.messageList.readList = [];
        this.messageList.unreadList = [];
        /* 筛选已读未读消息 */
        messageList.forEach((item) => {
          if (item.IsRead) {
            // 已读
            this.messageList.readList.push(item);
          } else {
            this.messageList.unreadList.push(item);
          }
        });
        // 传递给父组件未读消息条数
        this.$emit("input", this.messageList.unreadList.length);

        // 更多消息按钮显示
        // if (this.messageList.unreadList.length >= 4) {
        //   // 当未读消息大于等于4条时
        //   this.moreBtn = this.messageList.readList.length > 0 ? true : false;
        // } else {
        //   this.moreBtn = this.messageListTotal > 4 ? true : false;
        // }
        // console.log(this.messageList);
        this.moreBtn = this.messageListTotal > 4 ? true : false;

        // 判断是否大于四条
        if (this.messageListTotal > 4) {
          if (this.messageList.unreadList.length > 4) {
            //取前四条
            this.messageList.showUnreadList = this.messageList.unreadList.slice(0, 4);

            this.messageList.showReadList = [];
          } else {
            this.messageList.showUnreadList = this.messageList.unreadList;
            let count = 4 - this.messageList.unreadList.length;
            this.messageList.showReadList = this.messageList.readList.slice(0, count);
          }
        } else {
          this.messageList.showReadList = this.messageList.readList;
          this.messageList.showUnreadList = this.messageList.unreadList;
        }
      } else {
        this.$message({
          type: "error",
          message: res.Message,
        });
      }
    },
    // 查看更多数据
    showMoreDate() {
      this.moreBtn = false;
      this.messageList.showReadList = this.messageList.readList;
      this.messageList.showUnreadList = this.messageList.unreadList;
      console.log(this.messageList);
    },
    /**
     * 消息状态修改，从未读变已读
     * @param { Object } item: 消息数据
     */
    async changeMessageState(item) {
      // console.log(item);
      let w = window.open(); // 注意一定要在请求之前打开新页面，否则会被拦截
      // 判断是前台页面还是后台页面
      let apiUrl = item.IsBack ? this.$nuxtPage : this.$apiAir;//this.$apiAll : this.$apiAir;
      // 区分已读未读，已读跳转
      if (item.IsRead) {
        w.location.href = apiUrl.slice(0, -1) + item.WebUrl;
        return false;
      }

      // 未读
      const url = this.$api04 + "Basics/api/CustomerNoticeMsg/UpdateCustomerNotice";
      const res = await post(url, {
        NoticeId: item.ID,
      });

      if (res.IsOK) {
        // 获取消息列表
        await this.getMessageList();
        // 未读跳转
        w.location.href = apiUrl.slice(0, -1) + item.WebUrl;
      } else {
        this.$message({
          type: "error",
          message: res.Message,
        });
      }
    },
    /**
     * 是否接收新消息
     * @param { Boolean } val: 开关状态
     */
    async triggerSwitch(val) {
      const url = this.$api04 + "Basics/api/CustomerNoticeMsg/UpdateSwitch";

      const res = await post(url, {
        IsOpen: val,
      });

      if (res.IsOK) {
        // this.$message({
        //   type: 'success',
        //   message: res.Message || '更改成功'
        // });

        // 获取消息列表数据
        await this.getMessageList();
      } else {
        this.$message({
          type: "error",
          message: res.Message || "更改失败",
        });
      }
    },
    // 获取接收新消息的开关状态
    async getSwitchStatus() {
      const url = this.$api04 + "Basics/api/CustomerNoticeMsg/GetSwitch";

      const res = await post(url);
      if (res.IsOK) {
        // 是否接收消息状态开关
        this.messageSwitch = res.Results;
      } else {
        this.$message({
          type: "error",
          message: res.Message || "获取失败",
        });
      }
    },
  },
  beforeDestroy() {
    // 清除定时器
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style lang="scss">
.message_jiantou {
  position: absolute;
  border-bottom: solid 10px #fff;
  border-left: solid 10px transparent;
  border-right: solid 10px transparent;
  left: 67%;
  top: 8px;
  // box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
}
.messageContent {
  position: absolute;
  top: 20px;
  right: -106px;
  z-index: 99999;
  padding-top: 18px;
}
.padding-bottom-10 {
  padding-bottom: 10px;
}

.system-message {
  width: 370px;
  max-height: 560px;
  background: #fff;

  border-radius: 10px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);

  .system-message-container {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    .system-message-header {
      height: 43px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 15px 15px 10px 15px;

      .heder-font-style {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 18px;
      }

      .system-message-header__left {
        @extend .heder-font-style;
        color: #333333;
      }

      .system-message-header__right {
        position: relative;
        .el-checkbox__inner {
          width: 16px;
          height: 16px;
          border-radius: 50%;
        }

        .el-checkbox__inner::after {
          left: 5px;
          top: 1.5px;
        }

        .checkbox-info {
          @extend .heder-font-style;
          color: #777777;
        }

        .checkbox-tip {
          position: absolute;
          top: 15px;
          // z-index: 1;
          opacity: 0;
          z-index: -1;
          display: flex;
          animation: opacity-show 4s 1;

          @keyframes opacity-show {
            0% {
              opacity: 0;
              z-index: -1;
            }
            25% {
              opacity: 1;
              z-index: 1;
            }
            50% {
              opacity: 1;
              z-index: 1;
            }
            75% {
              opacity: 1;
              z-index: 1;
            }
            100% {
              opacity: 0;
              z-index: -1;
            }
          }
          // width: 65px;
          // height: 90px;

          .checkbox-tip__icon {
            margin-left: -15px;
            width: 25px;
            height: 45px;
            i {
              font-size: 45px;
              color: #4dae1f;
            }
          }

          .checkbox-tip__text {
            margin-left: 10px;
            padding-top: 30px;
            width: 65px;
            font-size: 13px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #4dae1f;
            line-height: 18px;
          }
        }
      }
    }

    .system-message-main {
      .system-message-main__top {
        padding: 5px 15px 0px 15px;
        max-height: 497px;
        box-sizing: border-box;
        overflow: auto;

        .system-message-main__top_read {
          .system-message-item:first-child {
            margin-top: 0;
          }
        }
        .system-message-main__top_unread {
          .system-message-item:first-child {
            margin-top: 0;
          }
        }
        .system-message-main__top_split {
          margin: 15px 0;
          border-top: 1px solid #e6e6e6;
        }
      }
      .system-message-main__top .system-message-main_top_bottom {
        display: flex;
        justify-content: center;
        padding-top: 10px;

        .message-tip {
          font-size: 11px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #777777;
          line-height: 16px;

          span:first-child {
            cursor: pointer;
          }
        }
      }

      .system-message-main__bottom {
        height: 20px;
      }

      .system-message-main__top::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 6px;
        /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }

      .system-message-main__top::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 3px;
        box-shadow: 0 0 5px #aaa inset;
        -webkit-box-shadow: 0 0 5px #aaa inset;
        background: #aaa;
      }

      .system-message-main__top::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: 0 0 5px #aaa inset;
        -webkit-box-shadow: 0 0 5px #aaa inset;
        border-radius: 3px;
        background: #fff;
      }
    }

    .system-message-empty {
      display: flex;
      justify-content: center;
      padding: 30px 0 50px 0;

      i {
        display: block;
        font-size: 50px;
        text-align: center;
      }

      span {
        display: block;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #aaaaaa;
        line-height: 18px;
      }
    }
  }
}

// .system-message::before {
//   content: " ";
//   position: absolute;
//   top: -5px;
//   bottom: 100%;
//   left: 67%;
//   width: 15px;
//   height: 15px;
//   background: #fff;
//   transform: rotate(135deg);
//   box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
// }
// .system-message::after {
//   content: " ";
//   position: absolute;
//   top: -10px;
//   bottom: 100%;
//   left: 65%;
//   width: 30px;
//   height: 30px;
//   background: #fff;
// }
</style>



// WEBPACK FOOTER //
// src/components/backstageManagement/public/rightTopMessage/index.vue